import { ErrorMessage } from 'formik';
import styled from 'styled-components';

// Dimensions of the error message. Kept here as the single source of truth so anything that
// needs to reserve/align to the error line (e.g. the customs item operators) can derive from
// these instead of hardcoding a value that silently drifts when these change.
export const ERROR_MESSAGE_MARGIN_REM = 0.5;
export const ERROR_MESSAGE_FONT_SIZE_REM = 1.4;
export const ERROR_MESSAGE_LINE_HEIGHT = 1.2;
// Total vertical space one reserved (empty) error line occupies: the single line's height plus
// its top and bottom margins.
export const RESERVED_ERROR_SPACE_REM =
	ERROR_MESSAGE_FONT_SIZE_REM * ERROR_MESSAGE_LINE_HEIGHT + ERROR_MESSAGE_MARGIN_REM * 2;

export const StyledFormikErrorMessage = styled(ErrorMessage)`
	margin: ${ERROR_MESSAGE_MARGIN_REM}rem;
	font-size: ${ERROR_MESSAGE_FONT_SIZE_REM}rem;
	color: ${({ theme }) => theme.colors.primaryDark};
`;

export const StyledErrorMessage = styled.div<{ reserveSpace?: boolean }>`
	margin: ${ERROR_MESSAGE_MARGIN_REM}rem;
	font-size: ${ERROR_MESSAGE_FONT_SIZE_REM}rem;
	line-height: ${ERROR_MESSAGE_LINE_HEIGHT};
	color: ${({ theme }) => theme.colors.primaryDark};

	/* When reserveSpace is set, always occupy one line so layout doesn't shift on error. */
	${({ reserveSpace }) => reserveSpace && `min-height: ${ERROR_MESSAGE_LINE_HEIGHT}em;`}
`;

export const StyledRequiredStar = styled.span`
	color: ${({ theme }) => theme.colors.primary};
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	font-size: 1.5rem;
`;
